module.exports = __webpack_public_path__ + "static/media/lock-icon.f786bc27.png";